const getCSS = (css, key) => {
  if (Object.prototype.hasOwnProperty.call(css, key)) return css[key];

  return css.default;
};

export const AdditionalColumns = ({ items, css }, device) => items.filter(column => column.show && !column[device]);

export default ({ items, css }, device) =>
  items
    .filter(column => column.show && column[device])
    .map(column => ({ ...column, className: getCSS(css, column.key) }));
